import { EffectCallback, useCallback, useEffect, useRef } from "react";
import { useComponentDidMount } from "./use-component-did-mount";
import * as _ from "lodash";

function deepCompareEquals(a: any, b: any) {
  return _.isEqual(a, b);
}

function useDeepCompareMemoize(value: any) {
  const ref = useRef();
  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export function useDeepCompareEffect(
  callback: EffectCallback,
  dependencies: any[],
  skipFirstRender = false,
) {
  const componentDidMount = useComponentDidMount();
  useEffect(
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    (skipFirstRender && componentDidMount) || !skipFirstRender
      ? callback
      : () => {},
    dependencies.map(useDeepCompareMemoize),
  );
}

export function useDeepCompareCallback(callback: any, dependencies: any[]) {
  return useCallback(callback, dependencies.map(useDeepCompareMemoize));
}
